<template>
  <div class='billing-data pt-3'>
    <strong>
      No sistema HO Fácil Web, todos os usuários são cadastrados como pessoas físicas. No entanto,
      para pagamento e emissão de nota fiscal, você pode escolher a opção que melhor se encaixa
      para gerar boleto ou fatura e nota fiscal. Escolha abaixo a opção desejada para preencher
      os dados de faturamento e nota fiscal:
    </strong>

    <div class="mt-3">
      <div class='w-100 d-flex flex-wrap justify-content-between'>
        <button
          @click="clearFieldsSwitchBetweenLegalEntity('person')"
          :class="billingData.type === 'person' ? 'hits_select ':'hits_no_select'"
        >
          <span>Pagar como PESSOA FÍSICA (CPF)</span>
        </button>

        <button
          @click="clearFieldsSwitchBetweenLegalEntity('company')"
          :class="billingData.type === 'company' ? 'hits_select ':'hits_no_select'"
        >
          <span>Pagar como PESSOA JURÍDICA (CNPJ)</span>
        </button>
      </div>
    </div>

    <div v-if="billingData.type === 'person'" class="mt-2">
      <label>Nome do usuário</label>
      <base-input-text
        v-model='v$.billingData.name.$model'
        type='text'
        placeholder='Digite o nome da pessoa que usará o sistema'
        block
        :error='getError(v$.billingData.name)'
      />
    </div>

    <div v-if="billingData.type === 'person'" class='mt-2 cpf-data_nascimento_telefone'>
      <div class="cpf">
        <label>CPF</label>
        <base-input-text
          v-model="v$.billingData.document.$model"
          type="text"
          placeholder="Digite o CPF"
          v-mask="['###.###.###-##']"
          block
          class="w-100"
          :error="getError(v$.billingData.document)"
        />
      </div>

      <div class="birthDate">
        <label>Data de Nascimento</label>
        <base-input-text
          v-model="v$.billingData.birthDate.$model"
          type="date"
          placeholder="Digite a data de Nascimento"
          class="w-100"
          :error="getError(v$.billingData.birthDate)"
        />
      </div>

      <div class="phone">
        <label>Telefone (WhatsApp)</label>
        <div class="w-100">
          <b-form-input
            id="input-phone"
            v-model="v$.billingData.phone.$model"
            type="text"
            class='input-cpf'
            style="height: 48px;"
            placeholder="(11) 99245-8774"
            aria-invalid
            :state='phoneIsValid'
            @keyup="validatePhone($event)"
            v-mask="['(##) #####-####']">
          </b-form-input>
        </div>
        <b-form-invalid-feedback :state='phoneIsValid'>
          {{getError(v$.billingData.phone)}}
        </b-form-invalid-feedback>
      </div>
    </div>

    <div class="mt-2" v-if="billingData.type === 'company'">
      <label>Razão Social</label>
      <base-input-text
        v-model='v$.billingData.companyName.$model'
        type='text'
        placeholder='Digite a razão social da empresa'
        block
        :error='getError(v$.billingData.companyName)'
      />
    </div>

    <div v-if="billingData.type === 'company'" class='mt-2 rows_2'>
      <div class="rows_2_div">
        <label>CNPJ</label>
        <base-input-text
          class="w-100"
          v-model="v$.billingData.cnpj.$model"
          type="text"
          placeholder="Digite o CNPJ"
          v-mask="['##.###.###/####-##']"
          :error="getError(v$.billingData.cnpj)"
        />
      </div>

      <div class="rows_2_div">
        <label>Telefone (WhatsApp)</label>
        <div class="w-100">
          <b-form-input
            id="input-phone"
            v-model="v$.billingData.phone.$model"
            type="text"
            class='input-cpf'
            style="height: 48px;"
            placeholder="(11) 99245-8774"
            aria-invalid
            :state='phoneIsValid'
            @keyup="validatePhone($event)"
            v-mask="['(##) #####-####']">
          </b-form-input>
        </div>
        <b-form-invalid-feedback :state='phoneIsValid'>
          {{getError(v$.billingData.phone)}}
        </b-form-invalid-feedback>
      </div>
    </div>

    <div v-if="billingData.type === 'company'" class='mt-2 rows_2'>
      <div class="rows_2_div">
        <label>Inscrição estadual (se houver)</label>
        <base-input-text
          v-model='v$.billingData.stateRegister.$model'
          type='text'
          placeholder='Digite a inscrição estadual'
          block
          :error='getError(v$.billingData.stateRegister)'
          v-if="billingData.type === 'company'"
        />
      </div>
      <div class="rows_2_div">
        <label>Inscrição municipal (se houver)</label>
        <base-input-text
          v-model='v$.billingData.cityRegister.$model'
          type='text'
          placeholder='Digite a inscrição municipal'
          block
          :error='getError(v$.billingData.cityRegister)'
          v-if="billingData.type === 'company'"
        />
      </div>
    </div>

    <div class='address mt-3' >
      <h2><strong>Endereço:</strong></h2>
      <div class="cpf-data_nascimento_telefone">
        <div class="cpf">
          <label>CEP</label>
          <div class='d-flex'>
            <b-form-input
              id='input-cep'
              v-model='v$.billingData.address.cep.$model'
              type='text'
              class='form-control'
              style='height: 48px;'
              placeholder='Digite o cep'
              @keyup='buscarCep($event)'
              :state='cepValido'
              aria-invalid
              v-mask="'##.###-###'">
            </b-form-input>
            <div>
              <b-spinner class='loading' v-if='checkingIfCEPExists' variant='primary' label='Spinning'></b-spinner>
            </div>
          </div>
          <b-form-invalid-feedback :state='cepValido'>
            {{ getError(v$.billingData.address.cep) }}
          </b-form-invalid-feedback>
        </div>

        <div class="birthDate">
          <label>Bairro</label>
          <base-input-text
            v-model='v$.billingData.address.neighborhood.$model'
            type='text'
            :disabled='!cepValido'
            placeholder='Digite o nome do bairro'
            class="w-100"
            :error='getError(v$.billingData.address.neighborhood)'
          />
        </div>

        <div class="phone">
          <label>Número</label>
          <base-input-text
            v-model='v$.billingData.address.number.$model'
            type='number'
            :disabled='!cepValido'
            placeholder='123'
            class="w-100"
            :error='getError(v$.billingData.address.number)'
          />
        </div>
      </div>

      <div  class="rows_2 mt-2">
        <div class="rows_2_div">
          <label>Rua</label>
          <base-input-text
            v-model='v$.billingData.address.street.$model'
            type='text'
            :disabled='!cepValido'
            placeholder='Digite o nome da rua ou avenida'
            block
            :error='getError(v$.billingData.address.street)'
          />
        </div>
        <div class="rows_2_div">
          <label>Complemento (opcional)</label>
          <base-input-text
            v-model='v$.billingData.address.complement.$model'
            type='text'
            :disabled='!cepValido'
            placeholder='Digite o complemento'
            block
            :error='getError(v$.billingData.address.complement)'
          />
        </div>
      </div>

      <div  class="rows_2 mt-2">
        <div class='rows_2_div'>
          <label>Cidade</label>
          <base-input-text
            v-model='v$.billingData.address.city.$model'
            type='text'
            placeholder='Digite o nome da cidade'
            block
            :error='getError(v$.billingData.address.city)'
          />
        </div>

        <div class="rows_2_div">
          <label>Estado</label>
          <base-input-select
            v-model='v$.billingData.address.state.$model'
            placeholder='Selecione um estado'
            :options='stateOptions'
            :error='getError(v$.billingData.address.state)'
            _key='key'
            _value='value'
          />
        </div>
      </div>
    </div>

    <div class='mt-3'>
      <b-alert
        show
        variant='danger'
        :class='{ hidden: !errors }'
      >
        {{ errors }}
      </b-alert>
    </div>

    <div class='d-flex mt-2'>
      <base-button
        danger
        class='w-50 mr-2'
        @click="back()"
      >
        Voltar
      </base-button>

      <b-overlay
        :show='loading'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-50'
      >
        <base-button
          block
          @click='next()'
        >
          Próximo
        </base-button>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, requiredIf } from '@/utils/validators'
import { mask } from 'vue-the-mask'
import { mapActions, mapGetters } from 'vuex'
import { helpers } from '@vuelidate/validators'
import { CPF, CNPJ } from '../../../utils/ValidateCPFCNPJ'
import { phoneValidator } from '../../../utils/phoneValidator'
import { verifyCNPJExists, verifyCPFExists } from '@/services/Search_CPF_CNPJ_CEP'
import moment from 'moment'

function validCNPJ() {
  return this.billingData.type === 'person' || this.CNPJIsValid
}

function validCEP() {
  return this.cepValido
}

function returnIfThePhoneIsCalid() {
  return this.phoneIsValid
}

export default {
  name: 'BillingDataAccess',
  setup() {
    return { v$: useVuelidate() }
  },
  props: {
    namePlan: { type: String }
  },
  data() {
    return {
      nextComponent: 'Payment',
      previousComponent: 'SelectNumberAccesses',
      loading: false,
      disableButtonToNotBuyOutOfTimePlan: true,
      plans: {},
      cepValido: null,
      CNPJIsValid: null,
      cpfIsValid: null,
      phoneIsValid: null,
      birthDateIsValid: null,
      checkingIfCPFExists: false,
      checkingIfCNPJExists: false,
      checkingIfCEPExists: false,
      birthDate: '',
      document: '',
      plan: {},
      typeOptions: [
        { key: 'person', value: 'Pessoa Física' },
        { key: 'company', value: 'Pessoa Jurídica' }
      ],
      stateOptions: [
        { key: 'Acre', value: 'Acre (AC)' },
        { key: 'Alagoas', value: 'Alagoas (AL)' },
        { key: 'Amapá', value: 'Amapá (AP)' },
        { key: 'Amazonas', value: 'Amazonas (AM)' },
        { key: 'Bahia', value: 'Bahia (BA)' },
        { key: 'Ceará', value: 'Ceará (CE)' },
        { key: 'Distrito Federal', value: 'Distrito Federal (DF)' },
        { key: 'Espírito Santo', value: 'Espírito Santo (ES)' },
        { key: 'Goiás', value: 'Goiás (GO)' },
        { key: 'Maranhão', value: 'Maranhão (MA)' },
        { key: 'Mato Grosso ', value: 'Mato Grosso (MT)' },
        { key: 'Mato Grosso do Sul', value: 'Mato Grosso do Sul (MS)' },
        { key: 'Minas Gerais', value: 'Minas Gerais (MG)' },
        { key: 'Pará', value: 'Pará (PA)' },
        { key: 'Paraíba', value: 'Paraíba (PB)' },
        { key: 'Paraná', value: 'Paraná (PR)' },
        { key: 'Pernambuco', value: 'Pernambuco (PE)' },
        { key: 'Piauí', value: 'Piauí (PI)' },
        { key: 'Rio de Janeiro', value: 'Rio de Janeiro (RJ)' },
        { key: 'Rio Grande do Norte', value: 'Rio Grande do Norte (RN)' },
        { key: 'Rio Grande do Sul', value: 'Rio Grande do Sul (RS)' },
        { key: 'Rondônia', value: 'Rondônia (RO)' },
        { key: 'Roraima', value: 'Roraima (RR)' },
        { key: 'Santa Catarina', value: 'Santa Catarina (SC)' },
        { key: 'São Paulo', value: 'São Paulo (SP)' },
        { key: 'Sergipe', value: 'Sergipe (SE)' },
        { key: 'Tocantins', value: 'Tocantins (TO)' }
      ]
    }
  },
  directives: { mask },
  computed: {
    ...mapGetters('user', {
      user: 'current'
    }),
    ...mapGetters('checkoutAccess', {
      billingData: 'getBillingData'
    }),
    ...mapGetters('plans', {
      getPlans: 'getPlans'
    }),
    errors() {
      return this.$store.getters['access/error']
    }
  },
  validations() {
    return {
      billingData: {
        type: {},
        name: { requiredIf: requiredIf(this.billingData.type === 'person') },
        birthDate: { requiredIf: requiredIf(this.billingData.type === 'person') },
        document: { requiredIf: requiredIf(this.billingData.type === 'person') },
        companyName: { requiredIf: requiredIf(this.billingData.type === 'company') },
        phone: { returnIfThePhoneIsCalid: helpers.withMessage('Telefone inválido', returnIfThePhoneIsCalid) },
        cnpj: { requiredIf: requiredIf(this.billingData.type === 'company') },
        stateRegister: {},
        cityRegister: {},
        address: {
          street: { required },
          number: { required },
          complement: {},
          neighborhood: { required },
          cep: { validCEP: helpers.withMessage('CEP inválido, por favor digite um cep válido para prosseguir.', validCEP) },
          city: { required },
          state: { required }
        }
      }
    }
  },
  methods: {
    ...mapActions('checkoutAccess', {
      handleSetBillingData: 'handleSetBillingData',
      handleSetType: 'handleSetType',
    }),
    ...mapActions('userActionLogs', {
      createUserActionLogs: 'createUserActionLogs'
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    back(){
      this.$emit('back-step')
      this.$emit('set-component', this.previousComponent)
    },
    async next() {
      this.loading = true
      await this.$store.dispatch('access/updateError', ``)
      let validate = await this.v$.$validate()
      const isValidPhone = this.validatePhone();

      if(!isValidPhone){
        await this.$store.dispatch('access/updateError', `Telefone inválido`)
        this.loading = false;
        return
      }

      validate = await this.v$.$validate()
      if(!validate){
        await this.$store.dispatch('access/updateError', `Preencha todos os campos corretamente`)
        this.loading = false;
        return
      }

      if (this.billingData.type === 'person'){
        const isDateOfBirthValid = this.validateInformedDateOfBirth()
        if(!isDateOfBirthValid){
          await this.$store.dispatch('access/updateError', `Data de nascimento inválida!`)
          this.loading = false;
          return
        }

        const isValid = await this.buscarCPF();
        if(!isValid){
          await this.$store.dispatch('access/updateError', `CPF inválido`)
          this.loading = false;
          return
        }
      }

      if (this.billingData.type === 'company'){
        const isCNPJValid = await this.buscarCNPJ();
        if(!isCNPJValid){
          await this.$store.dispatch('access/updateError', `CNPJ inválido`)
          this.loading = false;
          return
        }
      }

      if (this.user && this.user.role !== 'admin') {
        const log = {
          action: 'PREENCHEU_DADOS_FATURAMENTO'
        }
        await this.createUserActionLogs(log)
      }

      await this.$store.dispatch('access/updateError', ``)
      this.loading = false
      this.$emit('next-step')
      this.$emit('set-component', this.nextComponent)
    },

    validateInformedDateOfBirth() {
      const endDate = moment(new Date()).add(-18, 'year').toDate()
      const initialDate = moment(new Date(1900, 0, 1))
      const birthDate = moment(new Date(this.billingData.birthDate))
      return birthDate.isAfter(initialDate) && birthDate.isBefore(endDate) && this.billingData.birthDate
    },

    clearFieldsSwitchBetweenLegalEntity(type) {
      try {
        this.handleSetType(type)
        setTimeout(() => {
          this.billingData.companyName = ''
          this.billingData.cnpj = ''
          this.billingData.name = ''
          this.billingData.document = ''
          this.billingData.stateRegister = ''
          this.billingData.cityRegister = ''
          this.cpfIsValid = null
          this.CNPJIsValid = null
          /*if (this.billingData.type === 'person') {
            this.createHtmlInputCPF()
          }*/
        }, 100)
      } catch (e) {
      }
    },

    async buscarCep() {
      try {
        const cepComApenasNumeros = this.billingData.address.cep.replace('.', '').replace('-', '')
        if (cepComApenasNumeros) {
          this.cepValido = null
          if (cepComApenasNumeros.length > 7) {
            this.checkingIfCEPExists = true
            const { data: response } = await new Promise((resolve, reject) => {
              this.$api.get(`/service/cep/${cepComApenasNumeros}`)
                .then((data) => {
                  return resolve(data)
                })
                .catch((error) => {
                  return resolve(error.response)
                })
            })
            this.checkingIfCEPExists = false
            const { return: ok, message, result } = response
            this.cepValido = ok === 'OK' && !message
            this.billingData.address.street = result && result.logradouro ? result.logradouro : this.billingData.address.street
            this.billingData.address.neighborhood = result && result.bairro ? result.bairro : this.billingData.address.neighborhood
            this.billingData.address.city = result && result.localidade? result.localidade : this.billingData.address.city
            this.billingData.address.complement = result && result.complemento? result.complemento : this.billingData.address.complement
            this.billingData.address.state = result && result.uf ? this.stateOptions.find((x) => x.value.indexOf(result.uf) > 0).key : this.billingData.address.state
            return
          }
          this.cepValido = false
          return false;
        }
        this.cepValido = false;
        return  false;
      } catch (e) {
      }
    },

    async buscarCNPJ() {
      const cnpjComApenasNumeros = this.billingData.cnpj.replace(/[^\d]+/g, '')
      if (cnpjComApenasNumeros) {
        this.CNPJIsValid = null
        if (CNPJ(cnpjComApenasNumeros)) {
          this.checkingIfCNPJExists = true
          const { data: response } = await verifyCNPJExists(cnpjComApenasNumeros)
          this.checkingIfCNPJExists = false;
          const { cnpjExists } = response
          this.CNPJIsValid = cnpjExists
          return this.CNPJIsValid
        }
        this.CNPJIsValid = false
        return false
      }
      return false
    },

    async buscarCPF() {
      const cpfComApenasNumeros = this.billingData.document.replace(/[^\d]+/g, '')
      if (cpfComApenasNumeros && this.billingData.birthDate) {
        this.cpfIsValid = null
        if (CPF(cpfComApenasNumeros)) {
          this.checkingIfCPFExists = true
          //const { data: response } = await verifyCPFExists(cpfComApenasNumeros, this.billingData.birthDate)
          this.checkingIfCPFExists = false
          //const { cpfExists } = response
          this.cpfIsValid = true
          return this.cpfIsValid
        }
        this.cpfIsValid = false
        return false
      }
      return false;
    },

    validatePhone() {
      try {
        const phone = this.billingData.phone.replace(/[^\d]/g, '')
        this.phoneIsValid = phoneValidator(phone) && phone.length >= 10
        return this.phoneIsValid
      } catch (e) {
      }
    },

    getError(value) {
      if (value.$errors.length > 0) {
        return value.$errors[0].$message
      }
      return ''
    },
  },
  async mounted() {
    /*this.createHtmlInputCPF()*/
  },
  created() {
    try {
      const breadcrumb = {
        page: 'Comprar acessos',
        subPage: {
          name: 'Comprar acessos',
          active: false
        },
        tabs: [
          {
            name: 'Dados do faturamento',
            active: true
          }
        ]
      }
      this.setBreadcrumb(breadcrumb)
      this.buscarCPF()
      this.buscarCep()
      this.validatePhone()
      if (this.user && this.user.username) {
        this.billingData.email = this.user.username
      }
    } catch (e) {

    }
  }
}
</script>

<style lang="scss" scoped>

.loading {
  position: absolute;
  margin-left: -30px;
  margin-top: 12px;
  width: 1.5rem;
  height: 1.5rem;
}

.billing-data {
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    font-size: 15px;
    font-weight: 700;
  }

  .address {
    display: flex;
    flex-direction: column;
    gap: 4px;

    h2 {
      font-size: 20px;
      font-weight: bold;
    }

    .group {
      display: grid;
      grid-template-columns:  60% 38%;
      gap: 2%;
    }
  }

  .hits_select {
    text-align: center;
    border: 1px solid #04A8F3;
    padding: 5px;
    border-radius: 6px;
    background: #CBD63E;
    color: #262626;
    font-weight: 700;
    width: 49%;
    font-size: 15px;
  }

  .hits_no_select {
    border: 1px solid #04A8F3;
    padding: 5px;
    border-radius: 6px;
    background: transparent;
    color: #04A8F3;
    font-weight: 700;
    width: 49%;
    font-size: 15px;
  }

  .cpf-data_nascimento_telefone{
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%!important;
    flex-wrap: wrap;
    .cpf, .birthDate, .phone{
      width: 32%!important;
      min-width: 250px;
    }
  }

  .rows_2{
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;
    flex-wrap: wrap;
    .rows_2_div{
      width: 49%;
      min-width: 300px;
    }
  }
}

</style>
